//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";
import getUserId from "../../../core/GetToken";
import Settings from "../../../config/Settings";
import localStorage from "@react-native-async-storage/async-storage";

export const Authentication = createAsyncThunk(
  "Authentication",
  async (payload, { dispatch, getState }) => {
    try {
      console.log(payload , "payload")
      dispatch(gettingAuthentication());
      console.log(payload , "payload")
      const json = await UsePortalApi(
        `Patient/Authentication`,
        "Post",
        payload,
        false
      );
      console.log(payload , "after")
      if (json) {
        let password_statu = null;
                if (json.hasOwnProperty('StatusCode')) {
                    dispatch(gettingAuthenticationFailed(json.ResponseMessage));
                }
                else if (json[0].hasOwnProperty('resourceType')) {
                  console.log(json ,"auth jason")
                    json[0].hasOwnProperty('resourceType') && json[0].extension[1].valueBoolean != undefined && json[0].extension[1].valueBoolean == true ? password_statu = true : password_statu = false
                    console.log(json ,"auth jason2")
                    // if passwrod staus is true then it will be redirect the user to reset their passwrod.
                    if (password_statu) {
                      console.log(json ,"auth jason4")
                        // print some thing
                        setPassordResetInfo(json[0].extension[0].valueString, json[0].id, json[0].id)
                        _storeData(json[0].extension[0].valueString, json[0].id, 'No', )
                    } else {
                        //alert(json[0].name[0].text)
                        console.log(json ,"auth jason5")
                        _storeData(json[0].extension[0].valueString, json[0].id, 'No', )
                        // getUserId().then((data) => {
                        //     const item = JSON.parse(data);
                        //     // console.log(item)
                        // })
                    }
                    console.log(json ,"auth jason3")
                    dispatch(gettingAuthenticationSuccess(json[0]));


                    // sir code ...................
                    // dispatch(gettingAuthenticationSuccess(json));
                }
                else {
                    dispatch(gettingAuthenticationFailed("Login from Inside Api"));
                    alert('Your login details are incorrect.')
                }
      } else {
        dispatch(
          gettingAuthenticationFailed(
            json?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingAuthenticationFailed(error));
    }
  }
);
export const LogoutUser = () => {
  clearStorage();
  return (dispatch) => {
      getUserId().then((userInfo) => {
          const item = JSON.parse(userInfo);
          const queryString = '?Token=' + item.token

          console.log(queryString);

          var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          var requestOptions = {

              method: 'POST',
              headers: myHeaders,

              redirect: 'follow'
          };

          fetch(Settings.apiUrl + "Patient/Logout" + queryString, requestOptions)
              .then(response => response.json())
              .then(result => {
                  console.log(result)
                  alert(JSON.stringify(result))
                  if (result.StatusCode == 1) {
                      // aslert(result.ResponseMessage)
                  }
              })
              .catch(error => console.log('error', error));

      })
      dispatch(gettingUserLoginEnd());
  }
}



//clear storage
const clearStorage =  () => {
  try {
       localStorage.clear()
      //alert('Storage successfully cleared!')
  } catch (e) {
      //alert('Failed to clear the async storage.')
  }
};

const _storeData =  (usertoken, userId, isProxy,) => {
  try {
      const jsonValue = JSON.stringify({ "token": usertoken, "userid": userId, "proxy": isProxy,  "parentid": userId,  });
       localStorage.setItem('@userToken', jsonValue)

  } catch (error) {
      // Error saving data
  }
};

const setPassordResetInfo =  (usertoken, userId) => {
  try {
      const jsonValue = JSON.stringify({ "token": usertoken, "userid": userId });
       localStorage.setItem('@userPassordReset', jsonValue)

  } catch (error) {
      // Error saving data
  }
};


export const clearUserState = () => {
  return (dispatch) => {
      dispatch(gettingUserresetPasswordState())
  }
}
const AuthenticationSlice = createSlice({
  name: "Authentication",
  initialState: {
    isLoggedIn: false,
    isLoggin: false,
    AuthUser: [],
    error: false,
    passworderror: '',
    loginFailed: false,
    userPasswordStatus: false
  },
  reducers: {
    gettingAuthentication: (state, action) => {
      state.isLoggedIn= false;
      state.isLoggin= true;
      state.AuthUser= [];
      state.userPasswordStatus= false
    },
    gettingAuthenticationSuccess: (state, action) => {
      console.log(action , "action" )
      console.log(action.payload.extension[1].valueBoolean , "action1" )
                state.isLoggedIn= true;
                state.isLoggin= false;
                state.AuthUser= action.payload;
                state.loginFailed= false;
                state.userPasswordStatus= action.payload.extension[1].valueBoolean

    },
    gettingAuthenticationFailed: (state, action) => {
      state.isLoggedIn= false;
                state.isLoggin= false;
                state.AuthUser= [];
                state.passworderror= action.payload; //'Your Login details are incorrect';
                state.loginFailed= true;
                state.userPasswordStatus= false
    },
    gettingUserLoginEnd: (state, action) => {
      state.isLoggedIn= false;
      state.isLoggin= false;
      state.AuthUser= [];
      state.error= false;
      state.passworderror= '';
      state.loginFailed= false;
      state.userPasswordStatus= false
    }, 
     gettingUserresetPasswordState: (state, action) => {
      state.isLoggedIn=  false;
                state.isLoggin=  false;
                state.AuthUser=  [];
                state.error=  false;
                state.passworderror=  '';
                state.loginFailed=  false;
                state.userPasswordStatus=  false
    },
    gettingAuthenticationClear: (state, action) => {
      state.isLoggedIn= false;
      state.isLoggin= false;
      state.AuthUser= [];
      state.error= false;
      state.passworderror= '';
      state.loginFailed= false;
      state.userPasswordStatus= false
    },
  },
});
export const {
  gettingAuthentication,
  gettingAuthenticationSuccess,
  gettingAuthenticationFailed,
  gettingUserLoginEnd,
  gettingUserresetPasswordState,
  gettingAuthenticationClear,
} = AuthenticationSlice.actions;
export default AuthenticationSlice.reducer;
